<template>
  <PlatformBxFw
    ref="platform"
    :bridge="bridge"
    :localStoragePrefix="localStoragePrefix"
    :buttons="buttons"
    :outputs="outputs"
    :leds="leds"
    :lins="lins"
    :uarts="uarts"
    :languages="languages"
    :vbusSpecifications="vbusSpecifications"
    @initialized="platformInitialized"
  ></PlatformBxFw>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformBxFw from '@/device-platforms/PlatformBxFw.vue';

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformBxFw,
  },

  data: () => ({
    label: 'Kemper Lima 1.00',
    wasmUrl:'/Kemper_Frischwasser_Lima.wasm',
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 70.3, name: 'S1', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 35.3, name: 'S2', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.3, name: 'S3', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 50.3, name: 'S4', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 60.3, name: 'S5', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 0, name: 'S6', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.0, name: 'S7', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.0, name: 'S8', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.0, name: 'S9', },
      // { conversion: 'frequencyRaw', value: null, initialValue: 0.0, name: 'S10', },
      // { conversion: 'frequencyRaw', value: null, initialValue: 0.0, name: 'S11', },
      { conversion: 'frequencyHUBA_201_99003Flow', value: null, initialValue: 0.0, name: 'S10', },
      { conversion: 'frequencyHUBA_201_825151Flow', value: null, initialValue: 0.0, name: 'S11', },
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null },
      { name: 'R2', conversion: 'dutycyclePercent', value: null },
      { name: 'R3', conversion: 'dutycyclePercent', value: null },
      { name: 'R4', conversion: 'dutycyclePercent', value: null },
      { name: 'R5', conversion: 'digitalPercent', value: null },
      { name: 'R6', conversion: 'digitalPercent', value: null },
      { name: 'A1', conversion: 'dutycyclePercent', value: null },
      { name: 'A2', conversion: 'dutycyclePercent', value: null },
      { name: 'A3', conversion: 'dutycyclePercent', value: null },
    ],

    leds: [
        { state: null }
    ],

    lins: [
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', },
      { name: 'UART1', kind: 'VBus', },
      { name: 'UART2', kind: 'ModbusRtu', },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'English', short: 'en' },
    ],
  }),

  mounted() {
  },

  methods: {
    async prepareDevice() {
      this.bridge = await BasicPlatformWasiBridge.constructFromUrl(this.wasmUrl);
      this.$nextTick(() => {
        this.$refs.platform.prepareBridgeable();
      });
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
